import { __extends } from 'tslib';
import classNames from 'classnames';
import * as React from 'react';
import StepCSSTransitionGroup from '../Animations/StepCSSTransitionGroup.js';
import styles from './Dialog.module.scss.js';

var CONTENT_PADDING = 20;
var DialogBody = (function (_super) {
    __extends(DialogBody, _super);
    function DialogBody(props) {
        var _this = _super.call(this, props) || this;
        _this.onScroll = function (e) {
            var scrollPosition = e.currentTarget.scrollTop;
            var scrollHeight = e.currentTarget.scrollHeight - e.currentTarget.clientHeight - CONTENT_PADDING;
            _this.setState({
                showShadowTop: scrollPosition >= CONTENT_PADDING,
                showShadowBottom: scrollPosition <= scrollHeight,
            });
        };
        _this.state = {
            showShadowTop: false,
            showShadowBottom: false,
        };
        return _this;
    }
    DialogBody.prototype.componentDidMount = function () {
        var containerHasScroll = this._scrollContainer
            ? this._scrollContainer.scrollHeight > this._scrollContainer.clientHeight
            : false;
        this.setState({ showShadowBottom: containerHasScroll });
        this._scrollContainer.addEventListener('scroll', this.onScroll);
    };
    DialogBody.prototype.componentWillUnmount = function () {
        this._scrollContainer.removeEventListener('scroll', this.onScroll);
    };
    DialogBody.prototype.render = function () {
        var _a;
        var _this = this;
        var classNameBody = classNames(styles.body, this.props.className, (_a = {},
            _a[styles.showShadowTop] = this.state.showShadowTop,
            _a[styles.showShadowBottom] = this.state.showShadowBottom,
            _a));
        return (React.createElement(StepCSSTransitionGroup, { level: 2, id: this.props.id, className: classNameBody },
            React.createElement("div", { key: "content", id: this.props.id ? this.props.id + "-content" : undefined, ref: function (c) {
                    if (c) {
                        _this._scrollContainer = c;
                    }
                }, className: styles.content + " " + (this.props.className ? this.props.className : '') }, this.props.children)));
    };
    return DialogBody;
}(React.PureComponent));

export { DialogBody as default };
//# sourceMappingURL=DialogBody.js.map
